<template>
    <div class="form">
        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('global_search.headline.select_model') }}
            </div>
            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <label class="label label--required">
                        {{ trans('global_search.label.select_model') }}
                    </label>
                    <v-select v-model="selectedModel"
                        :options="modelOptions"
                        class="form-vue-select"
                    >
                        <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
                    </v-select>
                </div>
            </div>
        </section>

        <section class="form-section" v-if="selectedModel.value == 'client'">
            <div class="h:margin-bottom-6">
                <label class="form-section-heading">
                    {{ trans('global_search.headline.client') }}
                </label>
            </div>
            <global-search-client></global-search-client>
        </section>

        <section class="form-section" v-if="selectedModel.value == 'user'">
            <div class="h:margin-bottom-6">
                <label class="form-section-heading">
                    {{ trans('global_search.headline.user') }}
                </label>
            </div>
            <global-search-user></global-search-user>
        </section>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                selectedModel: {'value': 'user', 'label': 'Benutzer'},
                modelOptions: [
                    {'value': 'client', 'label': 'Mandant'},
                    {'value': 'user', 'label': 'Benutzer'},
                ],
            }
        },
    }
</script>
